<template>
<div>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Documentación Previa"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-success btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("Procesar") }}
          </button>
          <button
            type="button"
            v-if="false"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openProcessModal"
          >
            Procesar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="card-title mb-3">
          <strong>Documentos previos a la evaluación</strong>
        </p>
        <div
          class="row mb-2"
          v-for="(vj, j) in management_system_file"
          :key="j"
        >
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
              >Tamaño máximo del archivo 15 Mb</small
            >
          </div>
          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
              :id="`filename_${j}`"
              type="text"
              v-model="vj.filename"
              placeholder="Descripcion del archivo"
              @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
              >Es necesario agregar una descripción</small
            >
          </div>

          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmedDoc"
      @cancelled="cancelledDoc"
    />
 
  </div>
  <app-overlay-loader v-if="preloader" />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";

export default {
  name: "DocumentVigilance",
  mixins: [FormMixin, ModalMixin],
  props: {
    evalTestId: String,
  },
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      management_system_file: [],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      deleteModal: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.preloader = true;
      let url = `/accreditations/process/preAssessment/assessmentDet/${this.evalTestId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.management_system_file = response.data.management_system_file;
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.preloader = false;
        });
    },
    onChange(e, j) {
      const tmp = this.management_system_file[j];
      if (!tmp.file) return;

      if (tmp.file.size > 38700000) {
        this.$set(this.management_system_file[j], "file", null);
        this.$set(this.management_system_file[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 15MB");
        return;
      }
      if (!tmp.filename)
        this.$set(this.management_system_file[j], "filename", "");
      this.chargeFile(j);
    },
    openFileTab(file) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evalTestId;
      info['path'] = String(file.path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(file.path, "_blank");
      w.focus();
    },
    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },
    onKeyUp(j) {
      const tmp = this.management_system_file[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },
    removeRowFile(j) {
      this.management_system_file = this.management_system_file.filter(
        (value, index) => index != j
      );
    },
    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/accreditations/process/preAssessment/addFileVigilance`;
      const tmpo = this.management_system_file[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.management_system_file[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.management_system_file];
            tmp[j] = data;
            this.management_system_file = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    addFile() {
      if (this.management_system_file.length >= 101) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 100 archivos");
        return;
      }
      this.management_system_file.push({
        record_id: this.evalTestId,
        filename: null,
        file: null,
      });
    },
    confirmed() {
      this.preloader = true;
      const url = `/accreditations/process/preAssessment/process?evalTestId=${this.evalTestId}`;
      axiosPost(url)
        .then(({ data: res }) => {
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.preloader = false;
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    confirmedDoc() {
      const url = `/accreditations/process/preAssessment/destroyFileAttachVigilance?evalTestId=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "management_system_file") {
            const tmp = this.management_system_file.filter(
              (value, index) => index != this.tmp.j
            );
            this.management_system_file = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    openProcessModal() {
      this.deleteConfirmationModalActive = true;
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
    cancelledDoc() {
      this.deleteModal = false;
    },
    returnPage() {
      window.location.href = `/accreditations/process/preAssessment?tab=Documentos%20previos%20a%20la%20evaluación`;
    },
  },
};
</script>
